export const INSURANCE_PROGRAMS = {
    A: 'A: С ответственностью за все риски', // A
    B: 'B: С ответственностью за частную аварию', // B
    C: 'C: Без ответственности за повреждения, кроме случаев крушения', // C
}
